import { useMessages } from '@/i18n'
import { messages } from './messages'
import type { DesignImage } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { setLocalizedField } from '@/features/editor/lib/localizedField'
import { ImageUpload } from '@/features/editor/components/shared/ImageUpload'
import { useDesignImageTarget } from '../../design/useDesignImageTarget'

interface Props {
  element: DesignImage
  contentLang: ContentLang
  onUpdate: (patch: Partial<DesignImage>) => void
}

/**
 * Пустая картинка составного блока прямо на холсте: тот же `ImageUpload` и та же
 * цель догрузки, что у панели (`ImageSettings`), — грузится одним путём, URL уходит
 * в черновик, сохраняет кнопка панели. Клик по зоне заодно выделяет элемент —
 * это делает обёртка (`SortableDesignElement`), поэтому всплытие тут не глушится.
 */
export const CanvasImageUpload = ({ element, contentLang, onUpdate }: Props) => {
  const m = useMessages(messages)
  const target = useDesignImageTarget(element, contentLang)
  return (
    <div className="w-full">
      <ImageUpload
        value={null}
        onChange={(url) => onUpdate(setLocalizedField('imageUrl', contentLang, url ?? ''))}
        blockTarget={target}
        tone="canvas"
        label={m.dropImage}
      />
    </div>
  )
}
